import { render } from "./TwitchBlock.vue?vue&type=template&id=52ff7848"
import script from "./TwitchBlock.vue?vue&type=script&lang=js"
export * from "./TwitchBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__